export default "__VITE_ASSET__B$oL$Hfc__"